import { ValidatorInterface } from './ValidatorInterface';
import { AbstractValidator, ValidatorObject } from './AbstractValidator';
import { sprintf } from 'sprintf-js';
import Length from '../../../../source/js/shared/models/Geometry/Length';

/**
 * Validator that checks if the value is equal to or lower than the set maximum amount.
 */
export class MaximumValue extends AbstractValidator implements ValidatorInterface {

	/**
	 * Constructor.
	 *
	 * @param {ValidatorObject} options
	 */
	constructor(options: ValidatorObject) {
		super(options);

		const value = options.value ?? this.getDimensionValue();

		if (typeof value !== 'number') {
			throw new Error('The MaximumValue validator can only be used on numbers.');
		}

		this.value = value;
		this.maximum = this.maximum ?? this.getMaximum();
	}

	getMaximum(): number {
		return this.maximums[this.dimension] instanceof Length ? this.maximums[this.dimension].in_cm() : this.maximums[this.dimension];
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		if (super.getCustomMessage()) {
			return super.getCustomMessage();
		}

		const { dimensions } = this.getValidatorTranslationStrings();

		if (this.getDimension() === 'number_of_points' || this.getDimension() === 'side_amount') {
			return sprintf(dimensions.max, this.getDimensionLabel(), this.maximum, '');
		}

		return sprintf(dimensions.max, this.getDimensionLabel(), this.maximum, 'cm');
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {

		// Maximum sizes don't apply to cutouts.
		if ( this.getIsCutout() ) {
			return true;
		}

		const value = +this.value;
		if (isNaN(value)) {
			return false;
		}
		return value <= this.maximum;
	}
}
